// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__cSeHR","large":"styles_large__2XCWa"};